import { css } from 'linaria';

export const adviceTitle = css`
  width: 100%;
  margin-bottom: 32px;

  @media (--to-desktop) {
    margin-bottom: 16px;
  }
`;

export const adviceSlide = css`
  && {
    width: 380px;
    margin-right: 20px;
    border-radius: var(--rounding-xl);
    height: auto;

    @media (--only-desktop) {
      width: 300px;
    }

    @media (--only-tablet) {
      width: 260px;
    }

    @media (--only-mobile) {
      width: 100%;
      margin-right: 11px;
    }
  }
`;

export const adviceCard = css`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const adviceCardImageWrapper = css`
  height: 190px;

  @media (--only-desktop) {
    height: 150px;
  }

  @media (--only-tablet) {
    height: 130px;
  }

  @media (--only-mobile) {
    height: 139px;
  }
`;

export const adviceCardImage = css`
  border-radius: var(--rounding-xl) var(--rounding-xl) 0 0;
  height: 100%;
  width: 100%;

  @media (--only-mobile) {
    object-fit: cover;
  }
`;

export const adviceCardBody = css`
  padding: 16px 24px;
  background-color: var(--background-secondary);
  border-radius: 0 0 var(--rounding-xl) var(--rounding-xl);
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const adviceCardTopic = css`
  display: flex;
  column-gap: 4px;
  padding: 1px;
`;

export const adviceCardTitle = css`
  margin: 8px 0;

  @media (--only-desktop) {
    margin-bottom: 26px;
  }

  @media (--to-desktop) {
    margin-bottom: 46px;
  }
`;

export const adviceCardInfo = css`
  display: flex;
  column-gap: 16px;
  margin-top: auto;
`;

export const adviceCardInfoItem = css`
  display: flex;
  column-gap: 8px;
`;
